(() => {
  const SELECTOR = '.lp-commercial-state';

  function initializeCommercialState(root) {
    if (!root || root.dataset.lpInitialized === 'true') return;

    root.dataset.lpInitialized = 'true';

    const productInfo = root.closest('product-info');
    if (!productInfo) return;

    const dataElement = root.querySelector('.lp-commercial-state__data');
    const orderButton = root.querySelector('.lp-commercial-state__order');
    const soldoutButton = root.querySelector('.lp-commercial-state__soldout');
    const badge = root.querySelector('.lp-commercial-state__badge');
const message = root.querySelector('.lp-commercial-state__message');

    if (
  !dataElement ||
  !orderButton ||
  !soldoutButton ||
  !badge ||
  !message
) return;

    let variants = [];

    try {
      variants = JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('La Pampa: no se pudieron leer las variantes.', error);
      return;
    }

    const whatsappNumber = root.dataset.whatsapp;
    const productTitle = root.dataset.productTitle;

    function getProductForm() {
      return productInfo.querySelector('product-form form[action*="/cart/add"]');
    }

    function getSelectedVariant() {
      const productForm = getProductForm();
      const variantInput = productForm?.querySelector('input[name="id"]');

      if (!variantInput?.value) return null;

      return variants.find(
        (variant) => String(variant.id) === String(variantInput.value)
      );
    }

    function getNativeElements() {
  const productForm = getProductForm();

  const nativeButton = productForm?.querySelector('[name="add"]');
  const dynamicCheckout = productInfo.querySelector('.shopify-payment-button');

  return {
    nativeButton,
    dynamicCheckout,
  };
}

    function showElement(element) {
      if (!element) return;
      element.hidden = false;
      element.style.removeProperty('display');
    }

    function hideElement(element) {
      if (!element) return;
      element.hidden = true;
      element.style.setProperty('display', 'none', 'important');
    }

function updateCommercialState() {
  const variant = getSelectedVariant();
 
  const { nativeButton, dynamicCheckout } = getNativeElements();

  if (!variant || !nativeButton) return;

  const estado = String(variant.estado || '')
    .trim()
    .toLowerCase();

  root.hidden = false;
  root.classList.remove('is-available', 'is-order', 'is-soldout');

  hideElement(orderButton);
  hideElement(soldoutButton);
  hideElement(badge);
  hideElement(message);

  badge.textContent = '';
  message.textContent = '';

 if (estado === 'pedido') {
  root.classList.add('is-order');

  hideElement(nativeButton);
  hideElement(dynamicCheckout);

  showElement(orderButton);
  hideElement(message);
  return;
}

  if (estado === 'agotada') {
    root.classList.add('is-soldout');

    badge.textContent = 'Edición agotada';
    message.textContent =
      'Esta variante no está disponible actualmente.';

    hideElement(nativeButton);
    hideElement(dynamicCheckout);

    showElement(badge);
    showElement(soldoutButton);
    showElement(message);
    return;
  }

if (estado === 'disponible') {
  if (variant.available) {
    root.classList.add('is-available');

    showElement(nativeButton);
    showElement(dynamicCheckout);
  } else {
    root.classList.add('is-order');

    hideElement(nativeButton);
    hideElement(dynamicCheckout);

    showElement(orderButton);
  }

  return;
  
  }

  /*
   * Sin metacampo:
   * Dawn conserva su funcionamiento normal.
   */
  showElement(nativeButton);

  if (variant.available) {
    showElement(dynamicCheckout);
  } else {
    hideElement(dynamicCheckout);
  }
}

    orderButton.addEventListener('click', () => {
      const variant = getSelectedVariant();
      if (!variant) return;

      const message = [
        'Hola, quisiera consultar disponibilidad de:',
        '',
        productTitle,
        `Variante: ${variant.title}`,
        '',
        'Quedo atenta a la confirmación antes de realizar el pago.',
      ].join('\n');

      const whatsappUrl =
        `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

      window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    });

    /*
     * Escucha los cambios en talla y color mediante delegación.
     * Espera a que Dawn termine de actualizar la variante y el formulario.
     */
    productInfo.addEventListener('change', () => {
  const { nativeButton, dynamicCheckout } = getNativeElements();

  hideElement(nativeButton);
  hideElement(dynamicCheckout);

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      updateCommercialState();
    });
  });
});

    /*
     * Dawn puede reconstruir el formulario de compra.
     * Este observador vuelve a aplicar el estado después de ese reemplazo.
     */
    const observer = new MutationObserver(() => {
      requestAnimationFrame(updateCommercialState);
    });

    observer.observe(productInfo, {
      childList: true,
      subtree: true,
    });

    updateCommercialState();
  }

  function initializeAll() {
    document.querySelectorAll(SELECTOR).forEach(initializeCommercialState);
  }

  document.addEventListener('DOMContentLoaded', initializeAll);
  document.addEventListener('shopify:section:load', initializeAll);

  initializeAll();
})();